import {
  Companion_getInstance3g7lwy1meor8x as Companion_getInstance,
  ExternalDepositoswk9ddf49t2 as ExternalDeposit,
  Typere4zxecw7uiw as Type,
} from './databaseModels.mjs';
import {
  properties1qnxlk10mmfrs as properties,
  get_serializableAnnotations132wwdaanmitj as get_serializableAnnotations,
  SerializableProperty3ugfzrmvjw266 as SerializableProperty,
} from '../../../lightning-server-shared/com/lightningkite/serialization/SerializableProperty.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { KProperty1ca4yb4wlo496 as KProperty1 } from '../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { MonetaryValue3pm7jom4inigc as MonetaryValue } from './supportModels.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_amount(_this__u8e3s4) {
  return _this__u8e3s4.prop(ExternalDeposit_amount_getInstance());
}
function get_type(_this__u8e3s4) {
  return _this__u8e3s4.prop(ExternalDeposit_type_getInstance());
}
function get_checkNumber(_this__u8e3s4) {
  return _this__u8e3s4.prop(ExternalDeposit_checkNumber_getInstance());
}
function get_notes(_this__u8e3s4) {
  return _this__u8e3s4.prop(ExternalDeposit_notes_getInstance());
}
function prepareExternalDepositFields() {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var props = [ExternalDeposit_amount_getInstance(), ExternalDeposit_checkNumber_getInstance(), ExternalDeposit_type_getInstance(), ExternalDeposit_notes_getInstance()];
  var tmp = Companion_getInstance().m2a();
  properties(tmp, (it) => props);
}
function ExternalDeposit_amount$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(0);
}
function ExternalDeposit_amount$_get_name_$ref_2wbz1t() {
  return (p0) => p0.k20();
}
function ExternalDeposit_amount$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[0];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function ExternalDeposit_amount$_get_serializer_$ref_9t1ox4() {
  return (p0) => p0.j2j();
}
function ExternalDeposit_amount$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(0);
}
function ExternalDeposit_amount$_get_annotations_$ref_3sb63g() {
  return (p0) => p0.bz();
}
var ExternalDeposit_amountClass;
function ExternalDeposit_amount() {
  if (ExternalDeposit_amountClass === VOID) {
    class $ {
      constructor() {
        ExternalDeposit_amount_instance = this;
        var tmp = this;
        tmp.r5z_1 = lazy(ExternalDeposit_amount$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.s5z_1 = lazy(ExternalDeposit_amount$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.t5z_1 = lazy(ExternalDeposit_amount$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.r5z_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, ExternalDeposit_amount$_get_name_$ref_2wbz1t(), null);
        return tmp0.f2();
      }
      u5z(receiver) {
        return receiver.v5z_1;
      }
      m2j(receiver) {
        return new (MonetaryValue())(this.u5z(receiver instanceof ExternalDeposit() ? receiver : THROW_CCE()));
      }
      z5z(receiver, value) {
        return receiver.a60(value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof ExternalDeposit() ? receiver : THROW_CCE();
        return this.z5z(tmp, value instanceof MonetaryValue() ? value.a5s_1 : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.s5z_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, ExternalDeposit_amount$_get_serializer_$ref_9t1ox4(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.t5z_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, ExternalDeposit_amount$_get_annotations_$ref_3sb63g(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'ExternalDeposit_amount', VOID, VOID, [SerializableProperty()]);
    ExternalDeposit_amountClass = $;
  }
  return ExternalDeposit_amountClass;
}
var ExternalDeposit_amount_instance;
function ExternalDeposit_amount_getInstance() {
  if (ExternalDeposit_amount_instance === VOID)
    new (ExternalDeposit_amount())();
  return ExternalDeposit_amount_instance;
}
function ExternalDeposit_type$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(2);
}
function ExternalDeposit_type$_get_name_$ref_avrcr7() {
  return (p0) => p0.k20();
}
function ExternalDeposit_type$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[2];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function ExternalDeposit_type$_get_serializer_$ref_oxwz7e() {
  return (p0) => p0.j2j();
}
function ExternalDeposit_type$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(2);
}
function ExternalDeposit_type$_get_annotations_$ref_7yus5e() {
  return (p0) => p0.bz();
}
var ExternalDeposit_typeClass;
function ExternalDeposit_type() {
  if (ExternalDeposit_typeClass === VOID) {
    class $ {
      constructor() {
        ExternalDeposit_type_instance = this;
        var tmp = this;
        tmp.b60_1 = lazy(ExternalDeposit_type$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.c60_1 = lazy(ExternalDeposit_type$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.d60_1 = lazy(ExternalDeposit_type$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.b60_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, ExternalDeposit_type$_get_name_$ref_avrcr7(), null);
        return tmp0.f2();
      }
      e60(receiver) {
        return receiver.x5z_1;
      }
      m2j(receiver) {
        return this.e60(receiver instanceof ExternalDeposit() ? receiver : THROW_CCE());
      }
      f60(receiver, value) {
        return receiver.a60(VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof ExternalDeposit() ? receiver : THROW_CCE();
        return this.f60(tmp, value instanceof Type() ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.c60_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, ExternalDeposit_type$_get_serializer_$ref_oxwz7e(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.d60_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, ExternalDeposit_type$_get_annotations_$ref_7yus5e(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'ExternalDeposit_type', VOID, VOID, [SerializableProperty()]);
    ExternalDeposit_typeClass = $;
  }
  return ExternalDeposit_typeClass;
}
var ExternalDeposit_type_instance;
function ExternalDeposit_type_getInstance() {
  if (ExternalDeposit_type_instance === VOID)
    new (ExternalDeposit_type())();
  return ExternalDeposit_type_instance;
}
function ExternalDeposit_checkNumber$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(1);
}
function ExternalDeposit_checkNumber$_get_name_$ref_7ntl1u() {
  return (p0) => p0.k20();
}
function ExternalDeposit_checkNumber$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[1];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function ExternalDeposit_checkNumber$_get_serializer_$ref_rgul4p() {
  return (p0) => p0.j2j();
}
function ExternalDeposit_checkNumber$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(1);
}
function ExternalDeposit_checkNumber$_get_annotations_$ref_f8olur() {
  return (p0) => p0.bz();
}
var ExternalDeposit_checkNumberClass;
function ExternalDeposit_checkNumber() {
  if (ExternalDeposit_checkNumberClass === VOID) {
    class $ {
      constructor() {
        ExternalDeposit_checkNumber_instance = this;
        var tmp = this;
        tmp.g60_1 = lazy(ExternalDeposit_checkNumber$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.h60_1 = lazy(ExternalDeposit_checkNumber$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.i60_1 = lazy(ExternalDeposit_checkNumber$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.g60_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, ExternalDeposit_checkNumber$_get_name_$ref_7ntl1u(), null);
        return tmp0.f2();
      }
      e60(receiver) {
        return receiver.w5z_1;
      }
      m2j(receiver) {
        return this.e60(receiver instanceof ExternalDeposit() ? receiver : THROW_CCE());
      }
      j60(receiver, value) {
        return receiver.a60(VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof ExternalDeposit() ? receiver : THROW_CCE();
        return this.j60(tmp, (value == null ? true : typeof value === 'string') ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.h60_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, ExternalDeposit_checkNumber$_get_serializer_$ref_rgul4p(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.i60_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, ExternalDeposit_checkNumber$_get_annotations_$ref_f8olur(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'ExternalDeposit_checkNumber', VOID, VOID, [SerializableProperty()]);
    ExternalDeposit_checkNumberClass = $;
  }
  return ExternalDeposit_checkNumberClass;
}
var ExternalDeposit_checkNumber_instance;
function ExternalDeposit_checkNumber_getInstance() {
  if (ExternalDeposit_checkNumber_instance === VOID)
    new (ExternalDeposit_checkNumber())();
  return ExternalDeposit_checkNumber_instance;
}
function ExternalDeposit_notes$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(3);
}
function ExternalDeposit_notes$_get_name_$ref_pyfftq() {
  return (p0) => p0.k20();
}
function ExternalDeposit_notes$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[3];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function ExternalDeposit_notes$_get_serializer_$ref_56q0nd() {
  return (p0) => p0.j2j();
}
function ExternalDeposit_notes$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(3);
}
function ExternalDeposit_notes$_get_annotations_$ref_ytvioj() {
  return (p0) => p0.bz();
}
var ExternalDeposit_notesClass;
function ExternalDeposit_notes() {
  if (ExternalDeposit_notesClass === VOID) {
    class $ {
      constructor() {
        ExternalDeposit_notes_instance = this;
        var tmp = this;
        tmp.k60_1 = lazy(ExternalDeposit_notes$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.l60_1 = lazy(ExternalDeposit_notes$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.m60_1 = lazy(ExternalDeposit_notes$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.k60_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, ExternalDeposit_notes$_get_name_$ref_pyfftq(), null);
        return tmp0.f2();
      }
      e60(receiver) {
        return receiver.y5z_1;
      }
      m2j(receiver) {
        return this.e60(receiver instanceof ExternalDeposit() ? receiver : THROW_CCE());
      }
      j60(receiver, value) {
        return receiver.a60(VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof ExternalDeposit() ? receiver : THROW_CCE();
        return this.j60(tmp, (value == null ? true : typeof value === 'string') ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.l60_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, ExternalDeposit_notes$_get_serializer_$ref_56q0nd(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.m60_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, ExternalDeposit_notes$_get_annotations_$ref_ytvioj(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'ExternalDeposit_notes', VOID, VOID, [SerializableProperty()]);
    ExternalDeposit_notesClass = $;
  }
  return ExternalDeposit_notesClass;
}
var ExternalDeposit_notes_instance;
function ExternalDeposit_notes_getInstance() {
  if (ExternalDeposit_notes_instance === VOID)
    new (ExternalDeposit_notes())();
  return ExternalDeposit_notes_instance;
}
//region block: exports
export {
  get_amount as get_amountdkdz75wuiqhz,
  get_checkNumber as get_checkNumber2v6cfig98bffw,
  get_notes as get_notes3pjewr1fe36xv,
  prepareExternalDepositFields as prepareExternalDepositFields1kevjrv94n54x,
  get_type as get_type1pnmffeobzcga,
};
//endregion

//# sourceMappingURL=ExternalDepositFields.mjs.map
